export const DEFAULT_WELCOME_DESCRIPTION = `You can use the terminal to bridge assets from different chains to Mode, place a Trade on Mode Trade and query Synth&apos;s forecasting data all though simple prompts. Make sure to read the guide to prompting before getting started.`;

export const MINIMUM_SERIES_COUNT_FOR_TIME_SELECTION = 5;

export const DEFAULT_MODEL_ID = 'anthropic/claude-sonnet-4.6';
